import { configureStore } from "@reduxjs/toolkit";
import alertsSlice from "../features/alerts/alertsSlice";
import appUpdateSlice from "../features/appUpdate/appUpdateSlice";
import authSlice from "../features/auth/authSlice";
import championshipSlice from "../features/championship/championshipSlice";
import choicesSlice from "../features/choices/choicesSlice";
import dataStudioSlice from "../features/dataStudio/dataStudioSlice";
import datepickerSlice from "../features/datepicker/datepickerSlice";
import eventsSlice from "../features/events/eventsSlice";
import filesSlice from "../features/files/filesSlice";
import injuriesSlice from "../features/injuries/injuriesSlice";
import langSlice from "../features/lang/langSlice";
import markersSlice from "../features/markers/markersSlice";
import modsSlice from "../features/mods/modsSlice";
import photosSlice from "../features/photos/photosSlice";
import questionnaireSlice from "../features/questionnaire/questionnaireSlice";
import sessionsSlice from "../features/sessions/sessionsSlice";
import squadSlice from "../features/squad/squadSlice";
import statsCollectiveSlice from "../features/statsCollective/statsCollectiveSlice";
import statsIndivSlice from "../features/statsIndiv/statsIndivSlice";
import tagsSlice from "../features/tags/tagsSlice";
import trashSlice from "../features/trash/trashSlice";
import userSlice from "../features/user/userSlice";
import tablesSlice from "../features/tables/tablesSlice";
import dataPlaceSlice from "../features/dataPlace/dataPlaceSlice";
import pushNotifSlice from "../features/pushNotif/pushNotifSlice";
import tutosSlice from "../features/tutos/tutosSlice";
import preConfigSlice from "../features/preConfig/preConfigSlice";
import stliteSlice from "../features/stlite/stliteSlice";

export default configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  reducer: {
    auth: authSlice,
    user: userSlice,
    squad: squadSlice,
    sessions: sessionsSlice,
    markers: markersSlice,
    trash: trashSlice,
    championship: championshipSlice,
    choices: choicesSlice,
    mods: modsSlice,
    tags: tagsSlice,
    injuries: injuriesSlice,
    datepicker: datepickerSlice,
    events: eventsSlice,
    tables: tablesSlice,
    files: filesSlice,
    questionnaire: questionnaireSlice,
    stlite: stliteSlice,
    dataStudio: dataStudioSlice,
    statsCollective: statsCollectiveSlice,
    statsIndiv: statsIndivSlice,
    dataPlace: dataPlaceSlice,
    photos: photosSlice,
    preConfig: preConfigSlice,
    tutos: tutosSlice,
    pushNotif: pushNotifSlice,
    appUpdate: appUpdateSlice,
    lang: langSlice,
    alerts: alertsSlice,
  },
});
